
<template>
  <div>
    <dialog-loading loadingText="Salvando..." maxWidth="800px" v-if="saving"></dialog-loading>
    <v-dialog v-model="dialog" scrollable persistent max-width="800px" >
      <card-loading maxWidth="800px" v-if="loading"></card-loading>
      <v-card v-if="!loading">
        <v-card-title class="grey lighten-3 grey--text text--darken-3">
          <v-icon class="mr-2">mdi-alert</v-icon>
          <slot name="header"></slot>
        </v-card-title>
        <v-card-text class="mt-2">
          <div class="d-flex flex-column ">
            <slot name="content"></slot>

            <v-card class="mt-2">
              <v-card-title>
                <div class=" d-flex align-baseline">
                  <v-icon small >mdi-information</v-icon> 
                  <span class="ml-1 subtitle-2">Dados sobre {{model}}:</span>
                </div>
              </v-card-title>
              <v-card-text class="mt-2">
                <v-row>
                  <slot name="info"></slot>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
        </v-card-text>
        <v-card-actions>
          
          <slot name="actions"></slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'DialogTableExists',
  components: {
    SelectDepot: () => import("@/_backoffice/_registrations/components/shared/SelectDepot.vue"),
  },
  props:{
    saving:{
      type: Boolean,
      default: false,
    },
    loading:{
      type: Boolean,
      default: false,
    },
    model:{
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialog: true,
      modality_id: null,
    }
  },
}
</script>